@if (type === 'admin' && companyTypes?.length > 0) {
  <div class="company-type-management-header">
    <vwui-nav-header>
      {{ 'MENU.labels.management' | translate }}
    </vwui-nav-header>
  </div>
  @if (companyTypes?.length > 1) {
    <div class="company-type-selection">
      <ng-select [items]="companyTypes"
        [selectOnTab]="true"
        bindLabel="name"
        bindValue="id"
        required="true"
        [placeholder]="'PAGE_COMPANY_TYPES.placeholder.active_company_type' | translate"
        [(ngModel)]="activeCompanyTypeId"
        >
      </ng-select>
    </div>
  }
}

@for (navItem of navItems; track navItem) {
  @if (navItem.type === 'item') {
    <vwui-nav-item
      [href]="navItem.href"
      [iconName]="navItem.iconName"
      [routerLink]="['/' + navItem.href]"
      routerLinkActive="is-active"
      tabindex="-1"
      >
      {{navItem.label | translate}}
    </vwui-nav-item>
  }
  @if (navItem.type === 'header') {
    <div class="u-margin-b--md">
      <vwui-nav-header>
        {{navItem.label | translate}}
      </vwui-nav-header>
      @for (headerNavItem of navItem.items; track headerNavItem) {
        <vwui-nav-item
          [href]="headerNavItem.href"
          [iconName]="headerNavItem.iconName"
          [routerLink]="['/' + headerNavItem.href]"
          routerLinkActive="is-active"
          tabindex="-1"
          >
          {{headerNavItem.label | translate}}
        </vwui-nav-item>
      }
    </div>
  }
}
